import { mapActions, mapGetters, mapState } from "vuex"
import { getZoneParams } from "../../../../business/backpack"
import gameDetail from "../../../mixins/gameDetail"
import zoneRoleSelector from "../../../mixins/zoneRoleSelector"
import gameServiceZone from "../../../mixins/gameServiceZone"
import { USER_HELPER } from "../../../../constants/error_map"
import { getRateSubjectInfo } from "../../../../api/starRating"
import BackpackApi from "../../../../api/backpack"
import { showCgiError } from "@tencent/midas-cgi"
import { find } from "lodash"
import { FriendRecommendApi } from "../../../../api/friendRecomm"
import { getFormatedScore } from "../../../../api/starRating"
import { toBase64 } from "../../../../api/share"

const errTypes = {
  error: 2,
  loading: 3
}
export default {
  data() {
    return {
      errTypes,
      errInfo: {
        msg: "",
        type: errTypes.loading
      },
      backpackRecommStatusList: [],
      preAvatar: ""
    }
  },

  mixins: [gameDetail, zoneRoleSelector, gameServiceZone],

  computed: {
    ...mapGetters([
      "partitionInfo",
      "loginState",
      "sandbox",
      "vmallConfigByItemID",
      "currentItem",
      "pf",
      "sessionObj",
      "vmallConfigByAMSID",
      "vmallGoodsList",
      "userAgent",
      "isStDummyLoginState",
      "giftCardNums"
    ]),

    ...mapState({
      wxAvatar: ({ user }) => user.wxAvatar,
      qqAvatar: ({ user }) => user.qqAvatar
    }),

    /**
     * 设置大区信息参数
     * 保持是cgi需要的数据结构
     */
    zoneParams() {
      return getZoneParams(this.userZoneInfo)
    },

    /**
     * 判断用户是否可以切换大区
     * 若用户是从背包页过来，则无法切换大区
     * 如果是从推文等入口单独过来，则可以切换大区
     */
    canChangeZone() {
      return this.isStraightLink || !this.userZoneInfo.propsShowZoneRoleName
    },

    /**
     * 获取用户评分推荐信息等内容
     * @returns {function(*): ({[p: string]: *})}
     */
    currentGoodsRecommStatus() {
      return function (goods) {
        if (goods && this.backpackRecommStatusList?.length) {
          let status = this.backpackRecommStatusList?.filter(item => item?.subject_id === goods.itemExtend?.AMSID)

          if (status && status[0]) {
            return {
              ...status[0],
              formated_score: getFormatedScore(status[0].score, 2)
            }
          }
        }

        return {}
      }
    }
  },

  methods: {
    ...mapActions([
      "getVmallConfig",
      "setToastMsg",
      "setLoadingEnd",
      "setLoadingStart",
      "reportUserAction",
      "jumpToErrorPage",
      "getUserGiftCardNum"
    ]),

    /**
     * 主流程报错的后，外边调用方catch
     * 非主流程如选择推荐大区，内部调用catch
     * @returns {Promise<void>}
     */
    async initBaseInfo() {
      await this.getCurrentBizDetail({
        bizgroupid: this.groupId,
        bizid: this.busId
      })

      await this.getVmallConfig(this.currentItem)

      if (this.goodsId) {
        this.currentProp = this.vmallConfigByAMSID[this.goodsId]
        // 查询当前道具的分类信息
        let { subjectType } = getRateSubjectInfo(this.currentProp, this.currentItem.rateConfig)
        // 查询总分信息(这里subjectType直接赋值给currentProp的原因是之前其他同事编写的种草组件，要求以这种形式传入)
        this.currentProp.subjectType = subjectType
      }

      this.newZoneAndRoleSelector()

      // 获得缓存大区(旁路分支)
      try {
        let zoneInfo = await this.parseCachedZoneRole({
          userId: this.loginState.openid,
          offerId: this.currentItem?.ams?.offerid
        })

        let userZoneInfo = this.handleZoneInfo(zoneInfo)

        this.setZoneSelectorZoneInfo(userZoneInfo)
      } catch (e) {
        this.reportToRaven(e)
      }

      this.preRenderAvatar()
    },

    /**
     * 设置用户背包列表
     */
    async setBackpackIdList() {
      // 用户未选择大区
      if (!this.userZoneInfo?.zoneName) {
        this.setToastMsg(USER_HELPER.NO_SELECTED_ZONE)
        return
      }

      let offerId = this.currentItem?.ams?.offerid
      let backpackApi = new BackpackApi({
        pf: this.pf,
        sandbox: this.sandbox,
        sessionObj: this.sessionObj,
        offerId
      })

      // 获得背包返回的cgi结果
      let res = await backpackApi.queryBackpackList({
        ...this.zoneParams
      })

      if (res.ret !== 0) {
        throw new Error(showCgiError(res))
      }

      // 获取背包信息
      let bag = find(res.data.bag_list, {
        offer_id: offerId
      })

      if (!bag) {
        throw new Error(showCgiError(res))
      }

      // 筛选出vmall里背包的配置
      return bag.item_list.map(item => item.item_id).filter(item => item)
    },

    /**
     * 拉取大区选择组件
     */
    clickZoneAndRoleSelector(cb) {
      this.showZoneAndRoleSelector({
        offerId: this.currentItem.ams.offerid,
        userId: this.loginState.openid,
        confirmCb: zoneInfo => {
          let userZoneInfo = this.handleZoneInfo(zoneInfo)
          this.setZoneSelectorZoneInfo(userZoneInfo)
          if (userZoneInfo?.zoneId) {
            this.initGiftCardInfo()
          }

          cb && cb()
        }
      })
    },

    /**
     * 设置错误信息并且上报
     * 用于影响了主流程，并且是异常无法预知的错误
     * 注意reportToRaven是在各个页面实现，不是在mixin内的
     * 这样可以去区分每个页面的报错
     */
    setAndReportErr(e) {
      this.setDefaultErrorInfo()
      this.reportToRaven(e)
      this.setLoadingEnd()
    },

    /**
     * 设置默认报错信息
     */
    setDefaultErrorInfo() {
      this.errInfo = {
        msg: USER_HELPER.SYSTEM_BUSY,
        type: this.errTypes.error
      }
    },

    /**
     * 预渲染
     */
    preRenderAvatar() {
      let avatar = `${this.userAgent.weixin ? this.wxAvatar : this.qqAvatar || this.currentItem.icon}?r=forcepullavatar`

      toBase64(avatar, img => {
        this.preAvatar = img
      })
    },

    /**
     * 设置用户背包列表里物品的状态
     * 点赞、种草、评论等
     */
    async setBackPackListStatus(subjectIds) {
      let friendRecommendApi = new FriendRecommendApi({
        pf: this.pf,
        sandbox: this.sandbox,
        sessionObj: this.sessionObj,
        offerId: this.currentItem.ams.offerid
      })

      // 查询失败时仅提示，不影响主路径，也不需要提示
      try {
        let res = await friendRecommendApi.queryUserRecommStatusList({
          subject_id: subjectIds
        })

        if (res.ret !== 0) {
          return
        }

        // 要保证每次新获取的在最上面，这样可以保证每次都取到最新的值
        this.backpackRecommStatusList = res.data.item_list.concat(this.backpackRecommStatusList)
      } catch (e) {
        this.reportToRaven(e)
      }
    }
  }
}
